import {
  Component,
  Output,
  Input,
  EventEmitter,
  HostListener,
  AfterViewInit,
  OnDestroy,
  SimpleChanges,
  OnChanges,
  forwardRef
} from '@angular/core'

import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  UntypedFormControl,
  Validator
} from '@angular/forms'

import _ from 'lodash'
import $ from 'jquery'
import moment from 'moment'
import 'eonasdan-bootstrap-datetimepicker'
import {
  Datetimepicker,
  SetOptions as DatetimepickerOptions
} from 'eonasdan-bootstrap-datetimepicker'

const noop = () => {}
let identifier = 0

@Component({
  selector: 'app-datetime',
  templateUrl: './datetime.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatetimeComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => DatetimeComponent),
      multi: true
    }
  ],
  standalone: false
})
export class DatetimeComponent
  implements ControlValueAccessor, AfterViewInit, OnDestroy, OnChanges, Validator
{
  @Output() dateChange: EventEmitter<Date> = new EventEmitter<Date>()
  @Input() options: DatetimepickerOptions = {}
  @Input() placeholder = 'Choose date'
  @Input() utc = false

  private _readonly: boolean = null
  private _fireEvent = true

  get readonly(): boolean {
    return this._readonly
  }
  @Input() set readonly(value: boolean) {
    this._readonly = value

    if (this.control) {
      if (value) {
        this.control.disable()
      } else {
        this.control.enable()
      }
    }
  }
  @Input() required: boolean = null
  @Input() identifier = `app-datetime-${identifier++}`

  model: any
  date: any

  private control: Datetimepicker

  @HostListener('dateChange', ['$event'])
  private _onChange: (_: any) => void = noop
  private _onTouched: (_: any) => void = noop

  ngAfterViewInit() {
    this.init()
  }

  ngOnDestroy() {
    if (this.control) {
      this.control.destroy()
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['options'] && this.control) {
      if (!_.isEqual(changes['options'].currentValue, changes['options'].previousValue)) {
        this.control.destroy()
        this.control = null
        this.init()
      }
    }
  }

  writeValue(value: any): void {
    this.model = value || null
    if (this.control) {
      this._fireEvent = false
      const dt = this.utc
        ? moment.utc(this.model, 'YYYY-MM-DDTHH:mm:ssZ')
        : moment(this.model, 'YYYY-MM-DDTHH:mm:ssZ')
      this.control.date(dt)
      setTimeout(() => (this._fireEvent = true), 0)
    }
  }

  registerOnChange(fn: (_: any) => void): void {
    this._onChange = fn
  }

  onChange() {
    this._onChange(null)
  }

  registerOnTouched(fn: () => void): void {
    this._onTouched = fn
  }

  onTouched() {
    this._onTouched(null)
  }

  public validate(c: UntypedFormControl) {
    return this.required && !this.model ? { required: { valid: false } } : null
  }

  public setOptions(options: DatetimepickerOptions): void {
    Object.keys(options).forEach(v => {
      this.control[v](options[v])
    })
  }

  private init(): void {
    if (!this.control) {
      const $elem = ($('#' + this.identifier) as JQuery).datetimepicker(this.options || {})
      this.control = $elem.data('DateTimePicker')

      $elem.on('dp.change', (e: any) => {
        if (!this._fireEvent) {
          return
        }

        const newDate: any = e.date ? e.date : null

        this.date = newDate
        this.model = newDate ? newDate.toDate() : null
        this.dateChange.emit(this.model)
      })
    }
  }
}
